<template>
    <div id="card">
    <div id="chart1">
      <v-container class="pa-0 chart-icon" style="position:relative;top:150px;margin-top:-94px;">
       <v-row no-gutters style="position:relative;top:24px;" justify="center" align="center">
        <v-icon color="rgba( 241, 95, 49, 0.24)" size="30">{{ iconText }}</v-icon>
      </v-row>
      <v-row class="font-weight-light display-1" style="position:relative;top: 38px;" no-gutters justify="center" align="center">
        {{ chartValue }}
      </v-row>
      <v-row class="text-subtitle-1 font-weight-light grey--text" style="position:relative;top:38px;" no-gutters justify="center" align="center">
        {{ label }}
      </v-row>
      </v-container>
      <apexchart type="radialBar" height="250" :options="chartOptions" :series="series"></apexchart>
      <!-- <v-btn @click="updateChart">Update</v-btn> -->
    </div>
    </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  name: 'CircularGauge',
  mounted() {
    this.updateChart();
  },
  beforeUpdate() {
    this.updateChart();
  },
  components: {
    apexchart: VueApexCharts,
  },
  props: ['label','chartValue','maxLimit', 'iconText'],
  data() { 
    return {
      series: [],
      chartOptions: {
        labels: [''],
        chart: {
          height: 250,
          type: 'radialBar'
        },
        plotOptions: {
          radialBar: {
            startAngle: -120,
            endAngle: 120,
            hollow: {
              margin: 0,
              size: '70%',
              image: '',
              imageOffsetX: 0,
              imageOffsetY: 0,
              position: 'front',
              dropShadow: {
                enabled: true,
                top: 3,
                left: 0,
                blur: 4,
                opacity: 0.24
              }
            },
            track: {
              background: 'rgba( 241, 95, 49, 0.24)',
              strokeWidth: '80%',
              margin: 0, // margin is in pixels
            },
            dataLabels: {
              show: true,
              name: {
                offsetY: 60,
                show: true,
                color: '#00000099',
                fontSize: '17px'
              },
              value: {
                formatter: (val) => {
                  return this.chartValue;
                },
                color: '#000000de',
                fontSize: '36px',
                fontFamily: 'Roboto',
                fontWeight: 300,
                show: false,
              }
            }
          }
        },
        fill: {
            colors: ['rgb( 241, 95, 49)', 'rgb( 241, 95, 49)']
        },
        stroke: {
          lineCap: 'round'
        },
      },  
      
    }
  }, 
  methods: {
    updateChart() {
      let percent = (this.chartValue / this.maxLimit) * 100;
      this.series = [percent];
    },
  },
}
</script>
<style scoped>
.chart-icon{
  
}

</style>